export const constants = {

  /** 省略文字列  */
  EllipsisChars: '...',

  /** PerformanceNavigationTiming.type値に準拠  */
  NavigationType: {
    Forward: 'back_forward',
  },

  /** Cookieキー  */
  HttpCookieItemKey: {
    OktaStorageToken: 'okta-token-storage_idToken',
  },

  /** Session・LocalStorageキー  */
  HttpStorageItemKey: {
    DebugUserSsoKey: 'debug-sso-key',
  },

  /** HttpOriginalHeaderキー */
  HttpOriginalHeaderKey: {
    PrevPage: 'x-mym-prev-page',
    ScreenId: 'x-mym-screenid',
    DebugUserSsoKey: 'x-debug-sso-key',
  },

  /** ユーザステータス */
  UserStatus: {
    // 2024.5.8 MyMine Version1.5対応 Add Start
    Delete: -1,
    // 2024.5.8 MyMine Version1.5対応 Add End
    Active: 0,
    ActiveAndCaution: 1,
    Deactive: 2,
    Requesting: 3,
    RequestingUploader: 4,
    Rejected: 5,
    Approved: 6,
  },

  /** ユーザ権限 */
  UserRole: {
    Administrators: 1,
    Uploaders: 2,
    HCMUser: 3,
    RHQUser: 4,
    HDealerUser: 5,
    IDealerUser: 6,
    OtherUser: 7,
  },

  /** 会社種別 */
  CompanyCategory: {
    HCM: '01',
    HitachiRegionalHeadOffice: '02',
    DealerOperation: '03',
    SubsidiaryCompany: '04'
  },

  /** TermsOfUseテキスト種別 */
  TermsTextType: {
    Title: '0',
    Header: '1',
    Text: '2'
  },

  /** 公開種別 */
  PublishType: {
    Unpublish: '0',
    Publish: '1',
  },

  /** ニュース種別 */
  NewsType: {
    GlobalNews: '0',
    InternalNews: '1',
  },

  /** メッセージ文言*/
  Message: {
    InvalidRequest: 'Invalid request.',
    SystemError: 'A system error has occurred.\nPlease contact your system administrator.',
  },

  /** ファイルサイズ*/
  FileSize:
  {
    B: 1,
    KB: 2,
    MB: 3,
  },

  // 2024.9.16 MyMine Version2.0対応 Add Start
  /** Survey回答種別 */
  SurveyAnswerType: {
    Option: '1',
    Text: '2',
    // 2025.7.7 MyMine Version3.0対応 Add Start
    Checkbox: '3',
    Radiobutton: '4',
    // 2025.7.7 MyMine Version3.0対応 Add End
  },

  /** SurveyStatus */
  SurveyStatus: {
    Draft: '0',
    Scheduled: '1',
  },

  /** DataType */
  DataType: {
    Box: '1',
    News: '2',
    Contents: '3',
  },

  /** コーポレートカラー */
  CorporateColor: {
    Bradken: 'rgb(0 85 150)',
    Heparts: 'rgb(252 210 23)',
  },
  // 2024.9.16 MyMine Version2.0対応 Add End
  // 2025.3.5 MyMine Version2.1対応 Add Start
  /** Request回答種別 */
  RequestStatus: {
    InComplete: 0,
    Complete: 1,
    OutOfScope: 2,
  },
  /** コンテンツ種別 */
  ContentType: {
    Sales: 1,
  },
  // 2025.3.5 MyMine Version2.1対応 Add End
  // 2025.7.7 MyMine Version3.0対応 Add Start
  /** ReferenceLink種別 */
  ReferenceLink: {
    Url: '1',
    Email:'2'
  }
  // 2025.7.7 MyMine Version3.0対応 Add End
}